/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryResourceUtilizationRequest {
    getFixupPrototypeFunction() { return InventoryResourceUtilizationRequest.fixupPrototype; }

    static newInstance(model: Partial<InventoryResourceUtilizationRequest>): InventoryResourceUtilizationRequest {
        let obj = Object.assign(new InventoryResourceUtilizationRequest(), model);
        InventoryResourceUtilizationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryResourceUtilizationRequest>): InventoryResourceUtilizationRequest {
        if (!model) return null;
        return InventoryResourceUtilizationRequest.newInstance(<InventoryResourceUtilizationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryResourceUtilizationRequest) {
        if (!obj) return;

        models.InventoryResourceUtilizationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryResourceUtilizationRequest): boolean {
        Object.setPrototypeOf(obj, InventoryResourceUtilizationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.from_date === "string") {
            this.from_date = new Date(<string><any>this.from_date);
        }
        if (typeof this.to_date === "string") {
            this.to_date = new Date(<string><any>this.to_date);
        }
    }

    /**
     * Identifier of the inventory record to read utilization for, as returned by the list endpoint
     */
    resource_id: string;

    /**
     * Cloud account the inventory record belongs to
     */
    service_account_id: string;

    /**
     * Start of the window, inclusive. Hourly points from this hour onward are returned
     */
    from_date: Date;

    /**
     * End of the window, exclusive. The window may span at most 90 days, the retention of stored metrics
     */
    to_date: Date;

    /**
     * Metrics to return, up to 50. Leave out to get every metric collected for the resource
     */
    metric_names: Array<string>;

    /**
     * Also return enhanced monitoring series (AWS RDS Performance Insights OS metrics). Ignored for other resource types
     */
    include_enhanced_monitoring: boolean = false;

}
